<section class="worksheet-shell">
  <article class="panel worksheet-panel">
    <div class="worksheet-table-wrap">
      <table class="worksheet-table">
        <thead>
          <tr>
            <th class="sticky-col">Component</th>
            <th>Type</th>
            <th>Potential Failure</th>
            <th>Mode</th>
            <th class="metric-head"><span class="metric-head-label">Total FIT</span></th>
            <th class="metric-head"><span class="metric-head-label">SPF FIT</span></th>
            <th class="metric-head"><span class="metric-head-label">Latent FIT</span></th>
            <th class="metric-head"><span class="metric-head-label">Residual FIT</span></th>
            <th class="metric-head"><span class="metric-head-label">DC<sub>SPF</sub> %</span></th>
            <th class="metric-head"><span class="metric-head-label">DC<sub>LF</sub> %</span></th>
            <th class="metric-head"><span class="metric-head-label">SPF %</span></th>
            <th class="metric-head"><span class="metric-head-label">LF %</span></th>
            <th>Primary SM</th>
            <th>Secondary SM (Latent)</th>
            <th>Failure Effect</th>
            <th>System Effect</th>
            <th>Violates Safety Goal</th>
            <th>Op Temp C</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (rollup of componentRollups(); track rollup.componentDesignator) {
          <tr class="component-rollup-row" [attr.data-component-id]="rollup.componentDesignator"
            [class.selected-row]="isComponentRollupSelected(rollup.componentDesignator)"
            [class.status-white]="rollup.status === 'white'" [class.status-amber]="rollup.status === 'amber'"
            [class.status-green]="rollup.status === 'green'" (click)="onComponentRollupClick(rollup)"
            (dblclick)="onComponentRollupDoubleClick(rollup)"
            (contextmenu)="requestComponentContextMenu($event, rollup.componentDesignator)">
            <td class="sticky-col component-cell component-rollup-cell">
              <button type="button" class="rollup-toggle" [class.is-open]="isExpanded(rollup.componentDesignator)"
                [disabled]="!rollup.hasType || rollup.totalModes === 0"
                (click)="onRollupToggleClick($event, rollup)">
                {{ isExpanded(rollup.componentDesignator) ? '▾' : '▸' }}
              </button>
              <div>
                <strong>{{ rollup.componentDesignator }}</strong>
                <small>
                  @if (rollup.hasType) {
                  {{ rollup.assignedModes }} / {{ rollup.totalModes }} failure mode(s) assigned
                  } @else {
                  No component type assigned
                  }
                </small>
              </div>
            </td>
            <td>{{ rollup.componentType }}</td>
            <td>{{ rollup.hasType ? 'Potential failure modes available' : 'Assign type to enable failure modes' }}</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td>{{ rollup.operatingTemp }}</td>
            <td>
              <span class="risk-pill" [class.rollup-white]="rollup.status === 'white'"
                [class.rollup-amber]="rollup.status === 'amber'" [class.rollup-green]="rollup.status === 'green'">
                {{ getRollupStatusLabel(rollup) }}
              </span>
            </td>
          </tr>

          @if (rollup.hasType && isExpanded(rollup.componentDesignator)) {
          @for (mode of rollup.modeRows; track mode.modeCode) {
          <tr class="failure-mode-row"
            [class.selected-row]="mode.assignedRow && selectedWorksheetRowId() === mode.assignedRow.failureInstanceId"
            [attr.data-fi-id]="mode.assignedRow?.failureInstanceId ?? ''" (click)="selectFailureModeRow(rollup, mode)"
            (contextmenu)="requestFailureModeContextMenu($event, rollup, mode)">
            <td class="sticky-col component-cell mode-cell">
              <strong>{{ mode.modeCode }}</strong>
              <small>{{ mode.assignedRow?.failureInstanceId ?? 'No failure instance linked' }}</small>
            </td>
            <td>{{ rollup.componentType }}</td>
            <td>
              <div class="failure-cell">
                <span class="fault-dot" [class.high]="mode.assignedRow?.riskBand === 'high'"
                  [class.medium]="mode.assignedRow?.riskBand === 'medium'"
                  [class.low]="mode.assignedRow?.riskBand === 'low'" [class.incomplete]="!mode.assignedRow"></span>
                <div>
                  <strong>{{ mode.assignedRow?.failureName ?? 'Unassigned' }}</strong>
                  <small>{{ mode.modeName }}</small>
                </div>
              </div>
            </td>
            <td>{{ mode.modeCode }}</td>
            <td>{{ mode.assignedRow?.totalFit ?? '-' }}</td>
            <td>{{ mode.assignedRow?.spfFit ?? '-' }}</td>
            <td>{{ mode.assignedRow?.latentFit ?? '-' }}</td>
            <td>{{ mode.assignedRow?.residualFit ?? '-' }}</td>
            <td>{{ mode.assignedRow ? mode.assignedRow.diagnosticCoveragePct + '%' : '-' }}</td>
            <td>{{ mode.assignedRow ? (mode.assignedRow.dcLat * 100 | number:'1.1-1') + '%' : '-' }}</td>
            <td>{{ mode.assignedRow ? mode.assignedRow.singlePointPct + '%' : '-' }}</td>
            <td>{{ mode.assignedRow ? mode.assignedRow.latentFaultPct + '%' : '-' }}</td>
            <td>{{ mode.assignedRow?.safetyMechanism ?? '-' }}</td>
            <td>{{ mode.assignedRow?.latentMechanism ?? '-' }}</td>
            <td>{{ mode.assignedRow?.failureEffect ?? '-' }}</td>
            <td>{{ mode.assignedRow?.systemEffect ?? '-' }}</td>
            <td>{{ mode.assignedRow?.safetyGoal ?? '-' }}</td>
            <td>{{ mode.assignedRow?.operatingTemp ?? rollup.operatingTemp }}</td>
            <td>
              <span class="risk-pill" [class.high]="mode.assignedRow?.riskBand === 'high'"
                [class.medium]="mode.assignedRow?.riskBand === 'medium'"
                [class.low]="mode.assignedRow?.riskBand === 'low'" [class.incomplete]="!mode.assignedRow">
                {{ mode.assignedRow?.riskBand ?? 'unassigned' }}
              </span>
            </td>
          </tr>
          }
          }
          }
          @if (componentRollups().length === 0) {
          <tr>
            <td colspan="19" class="empty-row">No worksheet rows match the current filter.</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </article>

  <section class="metrics-grid">
    <article class="panel metric-panel">
      <h2>Totals</h2>
      <div class="metric-list">
        <div><span>Total Failure Rate</span><strong>{{ worksheetSummary().totalFit }} FIT</strong></div>
        <div><span>Protected FIT</span><strong>{{ worksheetSummary().protectedFit }} FIT</strong></div>
        <div><span>Residual FIT</span><strong>{{ worksheetSummary().residualFit }} FIT</strong></div>
      </div>
    </article>

    <article class="panel metric-panel">
      <h2>Single Point Faults (SPF)</h2>
      <div class="metric-list">
        <div><span>SPF FIT (&lambda;<sub>SPF</sub>)</span><strong>{{ worksheetSummary().singlePointFit }} FIT</strong>
        </div>
        <div><span>SPF Metric %</span><strong>{{ worksheetSummary().spfMetricPct }}%</strong></div>
        <div><span>Average DC<sub>SPF</sub></span><strong>{{ worksheetSummary().averageCoveragePct }}%</strong></div>
      </div>
    </article>

    <article class="panel metric-panel">
      <h2>Latent Faults (LF)</h2>
      <div class="metric-list">
        <div><span>Latent FIT (&lambda;<sub>LF</sub>)</span><strong>{{ worksheetSummary().latentFaultFit }} FIT</strong>
        </div>
        <div><span>LF Metric %</span><strong>{{ worksheetSummary().lfMetricPct }}%</strong></div>
        <div><span>Safety Goals</span><strong>{{ safetyGoals().length }}</strong></div>
      </div>
    </article>
  </section>

  @if (selectedComponent()) {
  <article class="panel detail-panel">
    <div class="detail-header">
      <div>
        <h2>{{ selectedComponent()?.id }} Detail</h2>
        <p class="subtitle">{{ selectedComponent()?.component_type }} at {{ selectedComponent()?.op_temp }} C</p>
      </div>
    </div>
    <div class="detail-stack">
      @for (failure of selectedComponent()?.failures; track failure) {
      <div class="failure-card">
        <p><strong>{{ failure.name }}</strong> ({{ failure.failure_mode.code }})</p>
        <p>{{ failure.failure_effect.name }} -> {{ failure.system_effect.name }}</p>
        <p>{{ failure.safety_goal.id }} {{ failure.safety_goal.description }}</p>
        <p>Primary SM: {{ failure.safety_mechanism.name || 'No mechanism' }} / DC {{
          failure.safety_mechanism.diagnostic_coverage ?? 0 }}</p>
      </div>
      }
    </div>
  </article>
  }
</section>